<div class="fx_modal_container" appModalDrag>
	<form dw-form [formGroup]="myform" class="fx_form_content">
		<div class="fx_form_group">

			<div dw-row style="min-height: 200px;" dwGutter="8">
				<!-- 支付金额 -->
				<div>
					<div dw-col dwXs="8" dwMd="8" dwLg="8" dwXl="8" fxFieldAuthorized fxFieldId="gca001">
						<dw-number-format formControlName="gca001" dwLabel="{{'fxed020-收款金额' | translate}}"
							[dwType]="'priceDecimal'" [dwMin]=0 [dwCode]="'default'" [dwPositiveNum]="2"
							[dwRequired]="true" [dwDisabled]="gca001disabled">
						</dw-number-format>
					</div>
					<div dw-col dwXs="8" dwMd="8" dwLg="8" dwXl="8" fxFieldId="gcaaobj">
						<fx-button-edit formControlName="gcaaobj" dwLabel="{{'fxed020-账款客户' | translate}}"
							name="gcaaobj_n1" (afterBlur)="gcaaobjChange($event)" (opened)="opengcaaobj($event)"
							(inputChanged)="eaatobjChange($event)" [optionData]="dropDownData2" [dwRequired]="true"
							[disabled]="true">
						</fx-button-edit>
					</div>
					<div dw-col dwXs="6" dwMd="6" dwLg="6" dwXl="6" fxFieldId="availableBalance">
						<dw-number-format formControlName="availableBalance" dwLabel="{{'fxed020-可用余额' | translate}}"
							[dwType]="'priceDecimal'" [dwMin]=0 [dwCode]="'default'" [dwDisabled]="true">
						</dw-number-format>
					</div>
				</div>
				<br />
				<!-- 支付方式 -->
				<div style="float: left">
					<span
						style="margin-left: 36px;font-size: 12px;font-weight: 400;color: rgba(0, 0, 0, 0.85);float: left;margin-top: 32px;">
						<span style="color: red;"> *</span>支付方式:
					</span>
					<div id="pay_lists" style="float: left;width: 650px;">
						<div id="JH003" style="float: left;width: 163px;margin: 14px 0 0 14px;border-style: groove;
							border-radius: 8px;height: 58px;border-color: white;border: solid 1px #d3cbcb;display:none;"
							(click)="pay_click($event)">
							<img style="width: 4.6rem;height: 5rem;
							margin: -12px 0 0 3px;" src="assets/img/home/支付-银联.png" />
							<span style="margin: 20px 0 0 0;position: absolute;">银联公对公</span>
						</div>
						<div id="JH004" style="float: left;width: 163px;margin: 14px 0 0 43px;border-style: groove;
						     padding: 16px;border-radius: 8px;height: 58px;border-color: white;border: solid 1px #d3cbcb;display:none;"
							(click)="pay_click($event)">
							<img style="width: 3.6rem;height: 3rem;margin: -13px 0 0 -8px;"
								src="assets/img/home/扫码.png" />
							<span style="margin: 6px 0 0 6px;position: absolute">扫码支付</span>
						</div>
						<div id="otherSample" style="float: left;width: 163px;margin: 14px 0 0 43px;border-style: groove;
						     padding: 16px;border-radius: 8px;height: 58px;border-color: white;border: solid 1px #d3cbcb;display:none;"
							(click)="pay_click($event)">
							<img style="width: 3.6rem;height: 3rem;margin: -13px 0 0 -8px;"
								src="assets/img/home/其他支付.png" />
							<span style="margin: 6px 0 0 6px;position: absolute">其他</span>
						</div>
					</div>
				</div>

			</div>

		</div>
	</form>
</div>
